import { RackOptions } from "../RackTypes"
import { RACK_COLORS } from "../constants"
import { getNamePlateMaterials, getCrownMaterials, getTopCrossmemberMaterials } from "./selection-utils"
import type { BuyRequest, IRogue } from '@/js/services/RogueTypes'
import { getSimpleForBuyRequest } from "@/js/helpers/buy-request"
import { findBundleProduct } from './product-lookup'

export function getCustomMaterials(rogue: IRogue, buyRequest: BuyRequest) {
  const rack = getSimpleForBuyRequest(buyRequest, rogue)
  const materials = {} as RackOptions['materials']
  const namePlateMaterials = getNamePlateMaterials(rogue, buyRequest)
  const crownMaterials = getCrownMaterials(rogue, buyRequest)
  const topCrossmemberMaterials = getTopCrossmemberMaterials(rogue, buyRequest)

  const txtGray = rack.attributes.rig_color?.toString().includes('Textured') && rack.attributes.rig_color?.toString().includes('Gray')
  const blackZincSafeties = findBundleProduct(rogue, buyRequest, 'safeties', true)?.name?.includes('Black')

  if (materials) {
    if (namePlateMaterials) {
      materials.nameplate = namePlateMaterials
    }

    if (txtGray) {
      materials.uprights = { main: { name: 'metal', color: '#5b5b59', material: 'powdercoat' } }
    }

    if (blackZincSafeties) {
      materials.safeties = { pipe: { material: 'isonite' } }
    }

    if (crownMaterials) {
      materials.crown = crownMaterials
    }

    if (topCrossmemberMaterials) {
      materials.topCrossmember = topCrossmemberMaterials
    }
  }

  return materials
}

export function handleSplitColorUprights(rigColor: string | undefined) {
  const colorKey = rigColor || 'Satin Black'

  // Stainless combo patterns
  if (rigColor === 'Satin Black / Stainless Steel' || rigColor === 'MG Black / Stainless Steel') {
    return { color: RACK_COLORS['Satin Black'], stainlessUprights: true }
  }

  if (rigColor === 'Textured Black / Stainless Steel') {
    return { color: RACK_COLORS['Textured Black'], stainlessUprights: true }
  }

  // Standard single color
  return { color: RACK_COLORS[colorKey] || RACK_COLORS['Satin Black'], stainlessUprights: false }
}
